/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//English (United Kingdom)
export default {
  'identity.account-menu.account-details.manage-profile-link': 'Account settings',
  'identity.account-menu.account-details.view-profile-tooltip': 'Profile',
  'identity.account-menu.account-menu-content.log-out-button': 'Log out',
  'identity.account-menu.account-menu-content.switch-account-button': 'Switch account',
  'identity.account-menu.account-menu-details.managed-account': 'This account is managed by <b>{managedBy}</b>',
  'identity.account-menu.account-menu-logged-out-state.log-in': 'Log in',
  'identity.account-menu.account-menu-popup.skeleton.tooltip': 'Account',
  'identity.account-menu.theme-switcher.dark.option': 'Dark',
  'identity.account-menu.theme-switcher.light.option': 'Light',
  'identity.account-menu.theme-switcher.match-browser.option': 'Match browser',
  'identity.account-menu.theme-switcher.theme-button': 'Theme',
};
